import React from 'react';
import TitleService from 'title-service';

import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Box,
    Divider,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Stack,
    Typography
} from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import PollIcon from '@mui/icons-material/Poll';
// project imports
import MainCard from 'ui-component/cards/MainCard';
import useAuth from 'hooks/useAuth';
import { DefaultRootStateProps } from 'types';
import { GetProfileSectionCards } from 'application/components';
// assets
import { IconLogout, IconSend } from '@tabler/icons';
import { getUserName, getUserProfileImage } from 'features/application/application-slice';
import CustomerAdministratorMenuItem from 'components/CustomerAdministratorMenuItem';
import ViewContentHouseAccessList from 'features/view/content/house/access/list/view-content-house-access-list'
import ViewPlayerAccessList from 'features/view/player/access/list/view-player-access-list'
import ProfileListComponent from './ProfileListComponent';

// ==============================|| PROFILE MENU ||============================== //

const ProfileContentSection = () => {
    const theme = useTheme();
    const customization = useSelector((state: DefaultRootStateProps) => state.customization);
    const userProfileName = useSelector(getUserName)
    const { logout, user } = useAuth();
    const handleLogout = async () => {
        try {
            await logout();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <>
            <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(100vh - 250px)', overflowX: 'hidden' }}>
                    <Box sx={{ p: 2 }}>
                        {/* <UpgradePlanCard /> */}
                        <CustomerAdministratorMenuItem />
                        <Divider />
                        <ProfileListComponent />
                        <ViewContentHouseAccessList key="ViewContentHouseAccessList-5" />,
                        <ViewPlayerAccessList key="ViewPlayerAccessList-6" />,
                        {/* {GetProfileSectionCards()} */}
                        <a href="http://playwatch.tv/Playwatch2023Survey.html" target="_blank">
                            <ListItemButton
                                sx={{ borderRadius: `${customization.borderRadius}px` }}
                            >
                                <ListItemIcon>
                                    <PollIcon stroke={1.5} size="2.3rem" />
                                </ListItemIcon>
                                <ListItemText primary={<Typography variant="h3">Take our survey</Typography>} />
                            </ListItemButton>
                        </a>
                        <a href="mailto:playwatch@playwatchkids.com?subject=Feedback">
                            <ListItemButton
                                sx={{ borderRadius: `${customization.borderRadius}px` }}
                            >
                                <ListItemIcon>
                                    <IconSend stroke={1.5} size="2.3rem" />
                                </ListItemIcon>
                                <ListItemText primary={<Typography variant="h3">Contact Us</Typography>} />
                            </ListItemButton>
                        </a>
                        <Divider />
                        <List
                            component="nav"
                            sx={{
                                width: '100%',
                                maxWidth: 350,
                                minWidth: 300,
                                backgroundColor: theme.palette.background.paper,
                                borderRadius: '10px',
                                [theme.breakpoints.down('md')]: {
                                    minWidth: '100%'
                                },
                                '& .MuiListItemButton-root': {
                                    mt: 0.5
                                }
                            }}
                        >
                            <ListItemButton
                                sx={{ borderRadius: `${customization.borderRadius}px` }}
                                onClick={handleLogout}
                            >
                                <ListItemIcon>
                                    <IconLogout stroke={1.5} size="2.3rem" />
                                </ListItemIcon>
                                <ListItemText primary={<Typography variant="h3">Logout</Typography>} />
                            </ListItemButton>
                        </List>
                    </Box>
                </PerfectScrollbar>
            </MainCard>
        </>
    );
};

export default ProfileContentSection;
